(() => {
  // Each set variant can name a free gift in its variant field custom.set_gift (Mo 2026-10-31: free kids pins
  // with every Natasha Mommy & Me set). templates/cart.vc-set-gifts.liquid lists each cart line's gift; this
  // script keeps one gift line per gift, marked _vc_free_pin, at the same quantity as the sets that name it.
  // An automatic discount in admin prices the gift at 0. Gifts a shopper adds on their own stay separate.
  if (window.vcFreePins) return;
  window.vcFreePins = true;

  const VIEW = 'cart?view=vc-set-gifts';
  const DECLINED_KEY = 'vcFreePinsDeclined';
  const UNPRICED_KEY = 'vcFreePinsUnpriced';

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const flag = (key, value) => {
    try {
      if (value === undefined) return sessionStorage.getItem(key) === '1';
      sessionStorage.setItem(key, value ? '1' : '0');
    } catch (e) {
      return false;
    }
  };

  const post = (path, payload) =>
    fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign(payload, { sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }))
    }).then((r) => r.json());

  // No Accept header: the view answers as a page, and its text is JSON. A missing view returns HTML, JSON.parse throws.
  const getGifts = () => fetch(root() + VIEW, { credentials: 'same-origin' }).then((r) => r.text()).then((t) => JSON.parse(t));
  window.vcSetGifts = getGifts;

  // Gift variant IDs seen in the last view, so a remove click on any gift line counts as declined.
  let giftIds = [];

  let busy = false;
  let again = false;
  let writing = false;

  const render = (json) => {
    if (location.pathname === root() + 'cart' || location.pathname === '/cart') {
      location.reload();
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && json && json.sections && typeof drawer.renderContents === 'function') {
      writing = true;
      try {
        drawer.renderContents({ sections: json.sections, items: json.items }, false);
      } catch (e) {
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
      }
      setTimeout(() => { writing = false; }, 300);
    }
  };

  const sync = async () => {
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    try {
      const view = await getGifts();
      const lines = view.lines || [];
      // want: gift variant ID -> sets in the cart that name it. A paid gift line without the property counts as neither.
      const want = {};
      lines.forEach((l) => { if (l.gift && !l.gift_line) want[l.gift] = (want[l.gift] || 0) + l.qty; });
      const giftLines = lines.filter((l) => l.gift_line);
      const ids = Object.keys(want).map(Number);
      giftLines.forEach((l) => { if (ids.indexOf(l.variant) === -1) ids.push(l.variant); });
      giftIds = ids;
      const totalSets = Object.keys(want).reduce((n, k) => n + want[k], 0);
      if (totalSets === 0) flag(DECLINED_KEY, false);

      // The declined and unpriced flags stay store-wide, as before: one gift exists today.
      let json = null;
      for (const id of ids) {
        const sets = want[id] || 0;
        const pins = giftLines.filter((l) => l.variant === id);
        const have = pins.reduce((n, l) => n + l.qty, 0);
        const target = flag(DECLINED_KEY) || flag(UNPRICED_KEY) ? 0 : sets;

        // While no more gifts than sets sit in the cart they should all be free; a price on them means the
        // discount is off, so take them out and stop adding. (More gifts than sets is a set just removed.)
        if (have > 0 && have <= sets && pins.some((l) => l.final > 0)) {
          flag(UNPRICED_KEY, true);
          for (const l of pins) json = await post('cart/change.js', { id: l.key, quantity: 0 });
          continue;
        }
        if (target === have && pins.length <= 1) continue;

        if (!pins.length) {
          const added = await post('cart/add.js', { items: [{ id: id, quantity: target, properties: { _vc_free_pin: 'true' } }] });
          if (added && added.status) continue;
          json = added;
        } else {
          for (let i = 0; i < pins.length; i++) {
            json = await post('cart/change.js', { id: pins[i].key, quantity: i === 0 ? target : 0 });
          }
        }
      }
      if (json) render(json);
    } catch (e) {
      // Leave the cart as the shopper left it.
    } finally {
      busy = false;
      if (again) {
        again = false;
        setTimeout(sync, 50);
      }
    }
  };

  let timer = null;
  const schedule = () => {
    if (writing) return;
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  };

  // A shopper who removes a free gift line keeps it removed until the sets leave the cart.
  document.addEventListener(
    'click',
    (event) => {
      const remove = event.target.closest('cart-remove-button');
      const row = remove && remove.closest('tr, li, .wt-cart__item, .cart-item');
      if (row && giftIds.some((id) => row.querySelector('[data-quantity-variant-id="' + id + '"]'))) flag(DECLINED_KEY, true);
    },
    true
  );

  ['cart-drawer:refresh', 'cart:updated'].forEach((ev) => document.addEventListener(ev, schedule));

  const watch = () => {
    // PUB_SUB_EVENTS is a page-level const from constants.js, not a window property.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    const target = document.getElementById('CartDrawer');
    if (target) new MutationObserver(schedule).observe(target, { childList: true });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true });
  else watch();
})();
